module.exports = __webpack_public_path__ + "icomoon.05a9fb75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/fonts/icomoon/icomoon.svg
// module id = 1324
// module chunks = 1